import { PluginKey } from '@atlaskit/editor-prosemirror/state';

import type { AISpeechToTextPluginState } from './types/AISpeechToTextPluginState';

export const aiSpeechToTextPluginKey: PluginKey<AISpeechToTextPluginState> =
	new PluginKey<AISpeechToTextPluginState>('aiSpeechToText');
